export default "__VITE_ASSET__07546e8b__"